import { render, staticRenderFns } from "./wine-collector2.vue?vue&type=template&id=10dd9cc7&scoped=true"
import script from "./wine-collector2.vue?vue&type=script&lang=js"
export * from "./wine-collector2.vue?vue&type=script&lang=js"
import style0 from "./wine-collector2.vue?vue&type=style&index=0&id=10dd9cc7&prod&scoped=true&lang=css"
import style1 from "./wine-collector2.vue?vue&type=style&index=1&id=10dd9cc7&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd9cc7",
  null
  
)

export default component.exports